import React from "react";
import {
  Box, Typography, Paper, Button,
  Stepper, Step, StepLabel, Divider
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Routings from "../../Routings";

const STEPS = ["Student Registration", "Parent Details", "Payment", "Confirmation"];

const NEXT_STEPS = [
  "Evaluation (if applicable) will be scheduled",
  "Payment confirmation will be reviewed",
  "Enrolment confirmation sent via email"
];

const currentYear  = new Date().getFullYear();

const RegistrationSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const applicationNumber = location.state?.applicationNumber || "—";

  return (
    <Box sx={{ minHeight: "100vh", pb: 6 }}>
      {/* Stepper bar */}
      <Box sx={{ maxWidth: 860, mx: "auto", pt: 4, px: { xs: 2, md: 3 }, mb: 4 }}>
        <Typography variant="h5" fontWeight={700} sx={{ color: "#1a1a2e", mb: 0.5 }}>
          Cumming Tamil School&nbsp; {currentYear} -{String(currentYear + 1).slice(-2)}
        </Typography>
        <Stepper activeStep={3} alternativeLabel sx={{ mt: 3 }}>
          {STEPS.map(label => (
            <Step key={label} completed>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      {/* Success card */}
      <Box sx={{ maxWidth: 620, mx: "auto", px: { xs: 2, md: 3 } }}>
        <Paper sx={{ borderRadius: 3, overflow: "hidden", boxShadow: "0 4px 24px rgba(0,0,0,0.10)" }}>

          {/* Green success banner */}
          <Box sx={{
            px: 4, py: 3, textAlign: "center",
            background: "linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%)",
            borderBottom: "1px solid #c8e6c9"
          }}>
            <Typography sx={{ fontSize: 40, mb: 0.5 }}>🎉</Typography>
            <Typography variant="h6" fontWeight={700} sx={{ color: "#2e7d32" }}>
              Registration Successful!
            </Typography>
            <Typography variant="body2" sx={{ color: "#388e3c", mt: 0.5 }}>
              Your application has been submitted for {currentYear} -{String(currentYear + 1).slice(-2)}.
            </Typography>
          </Box>

          <Box sx={{ px: 4, py: 3 }}>
            {/* Application number */}
            <Box sx={{
              borderRadius: 2, mb: 3,
              background: "linear-gradient(135deg, #1a237e 0%, #283593 100%)",
              p: 2.5, textAlign: "center"
            }}>
              <Typography variant="caption" sx={{ color: "#9fa8da", letterSpacing: 2, textTransform: "uppercase" }}>
                Application Number
              </Typography>
              <Typography variant="h5" fontWeight={700} sx={{ color: "#fff", mt: 0.5, letterSpacing: 1 }}>
                {applicationNumber}
              </Typography>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: "center" }}>
              A confirmation email has been sent to your registered email.
              Please save your application number for future reference.
            </Typography>

            <Divider sx={{ mb: 2.5 }} />

            {/* What happens next */}
            <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>
              What happens next?
            </Typography>
            {NEXT_STEPS.map((step, i) => (
              <Box key={i} sx={{ display: "flex", gap: 1.5, mb: 1 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, flexShrink: 0 }}>
                  {i + 1}.
                </Typography>
                <Typography variant="body2" color="text.secondary">{step}</Typography>
              </Box>
            ))}

            <Button
              fullWidth variant="contained"
              onClick={() => navigate(Routings.HOME || "/")}
              sx={{
                mt: 3, py: 1.5,
                background: "linear-gradient(90deg, #1a237e, #283593)",
                borderRadius: 2, textTransform: "none",
                fontSize: "1rem", fontWeight: 600
              }}
            >
              Back to Home
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default RegistrationSuccess;
